import { Flex, Text } from "@gravity-ui/uikit";

import { termsPromotion } from "../../../ResponsivePromotionWidget.constants";
import { PromotionElement } from "./PromotionElement";

export const PromotionSection = () => {
  return (
    <Flex
      direction={"column"}
      gap={4}
      width={"100%"}
      style={{
        backgroundColor: "var(--g-color-base-generic)",
        borderRadius: "10px",
        padding: 10,
      }}
    >
      <Text variant="subheader-1">Условия акции:</Text>
      <Flex direction={"column"} gap={3} style={{ padding: "0 10px 0 10px" }}>
        {termsPromotion.map((term, index) => (
          <PromotionElement
            key={`term_element_${index}`}
            id={++index}
            {...term}
            success={true}
          />
        ))}
      </Flex>
    </Flex>
  );
};
